<form
  (ngSubmit)="submitForm()"
  [formGroup]="formGroup"
  [nzLayout]="'vertical'"
  nz-form>
  <nz-form-item>
    <nz-form-control [nzErrorTip]="formProvider.getErrorTip()">
      <nz-input-group
        [nzPrefixIcon]="'instagram'"
        [nzSize]="'large'"
        [nzSuffix]="suffix">
        <input
          (input)="onPayloadInput($event)"
          [formControlName]="'payload'"
          [placeholder]="formProvider.getPlaceholder()"
          [type]="'text'"
          nz-input />
      </nz-input-group>
      <ng-template #suffix>
        <button
          [disabled]="formGroup.invalid"
          [nzLoading]="state() === DownloadState.LOADING"
          [nzShape]="'circle'"
          [nzSize]="'large'"
          [nzType]="'primary'"
          i18n-title="@@download-form-button-title"
          nz-button
          title="Download">
          <nz-icon [nzTheme]="'outline'" [nzType]="'download'" />
        </button>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</form>
